@let blok = this.block();
@let bgClass = getDecorationColorClasses();
@if (visible()) {
    <section
        [attr.id]="blok.sectionId || null"
        [ngClass]="getOuterClasses()"
        class="w-full">
        <div class="relative md:py-14 px-0 md:px-5">
            <div
                class="flex flex-col md:grid auto-rows-fr grid-cols-1 md:grid-cols-2 max-w-content-width mx-auto relative top-1/2 z-10 justify-between"
                [class]="[baseClass + '--wrapper', baseClass + '--image-' + (blok.imagePosition === 'right' ? 'right' : 'left')].join(' ')"
                [ngClass]="getGapClasses()">
                <div
                    class="flex flex-col justify-center px-5 md:px-0"
                    [class]="baseClass + '--content'">
                    @for (child of blok.children; track child['_uid']) {
                        <s1-cms-component [blok]="child"/>
                    }
                </div>
                <div

                    [class]="baseClass + '--image'"
                    [ngClass]="bgClass"
                    class="p-5 md:p-0 h-full flex justify-center items-center md:!bg-transparent">
                    <picture class="block w-full"
                             [class.mx-auto]="!blok.imageInside"
                             [class.right-0]="blok.imageInside && blok.imagePosition === 'right'"
                             [class.left-0]="blok.imageInside && blok.imagePosition === 'left'"
                             [ngClass]="getImageClasses()"
                             [class]="[baseClass + '--image-' + blok.imageAlign,
                             baseClass + '--image-tablet-' + blok.imageAlignTablet,
                             baseClass + '--image-desktop-' + blok.imageAlignDesktop].join(' ')">
                        @if (blok.imageDataDesktop?.filename) {
                            <source media="(min-width: 992px)"
                                    [srcset]="blok.imageDataDesktop!.filename | imageUrlTransformPipe : 1440: 0"/>
                        }
                        @if (blok.imageDataTablet?.filename) {
                            <source media="(min-width: 768px)"
                                    [srcset]="blok.imageDataTablet!.filename | imageUrlTransformPipe : 992: 0"/>
                        }
                        @if (blok.imageData?.[0]?.filename) {
                            <img [src]="(blok.imageData || [])[0]!.filename | imageUrlTransformPipe : 768: 0"
                                 [attr.alt]="(blok.imageData || [])[0]!.alt"
                                 class="rounded-2xl"
                                 [attr.loading]="blok.lazyLoad ? 'lazy' : null" />
                        }
                    </picture>
                </div>
            </div>

            @if (blok.imagePosition === 'right') {
                <div
                    class="hidden md:block absolute top-0 bottom-1/2 left-0 right-0 md:bottom-0 md:left-0 md:right-1/2 md:bg-left"></div>
                <div [ngClass]="getBgSizeClass()"
                     class="hidden md:block absolute top-1/2 bottom-0 left-0 right-0 md:top-0 md:right-0 rounded-bl-2xl rounded-tl-2xl"></div>
            } @else {
                <div [ngClass]="getBgSizeClass()"
                     class="hidden md:block absolute top-1/2 bottom-0 left-0 right-0 md:top-0 md:left-0 rounded-br-2xl rounded-tr-2xl">
                </div>
                <div
                    class="hidden md:block absolute top-0 bottom-1/2 left-0 right-0 md:bottom-0 md:left-1/2"></div>
            }
        </div>
    </section>
}
